<style>
#main__wrapper {
  height: 100%;
  margin-top: -25px;
}
.legend {
  display: inline-block;
  width: 16px;
  height: 16px;
}
.legend:hover,
.legend > img:hover {
  transition: box-shadow 0.2s;
}
.legend:not(.legend-img):hover {
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.75);
}
.legend > img:hover {
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.75);
}
.legend-circle {
  border-radius: 50%;
  background-color: black;
}
.legend-poly {
  border-radius: 10%;
  background-color: black;
}
.legend-line {
  height: 2px;
  background-color: black;
  top: 50%;
}
#DEMLegendModal .legend-transition.legend-poly,
#DEMLegendModal .legend.legend-poly,
#DEMLegendModal .legend-transition.legend-circle,
#DEMLegendModal .legend.legend-circle {
  position: relative;
  top: 3px;
}
.legend-img {
  top: -2px;
  position: relative;
}
#DEMLegendModal .v--modal-box.v--modal {
  min-width: 380px !important;
  min-height: 280px !important;
}
#DEMLegendModal .modal__content {
  overflow-y: auto !important;
}
#DEMLegendModal .modal__footer {
  display: none;
}
#DEMLegendModal .v-expansion-panel {
  box-shadow: none;
  border-bottom: 1px solid lightgrey;
}
#DEMLegendModal .v-expansion-panel__header {
  padding: 0;
}
.v-card > ul > li:last-child {
  border-bottom: 0px;
}
.v-card > ul > li:first-child {
  border-top: 1px solid lightgrey;
}
.zoomToExtent {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 10px;
}
.zoomToExtent > i {
  height: 100%;
}
</style>

<template>
  <Modal modalName="DEMLegendModal" title="Legenda - DEM" :buttons="['']">
    <v-img :src="require('@/LegendDEM.png')" height="550px" width="200px"></v-img>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

export default {
  data: () => ({}),
  components: {
    Modal
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/start/modals/DEMLegend.vue